import React, { createContext, useEffect, useState } from "react";

const SettingsContext = createContext({
  settings: { theme: "LIGHT" },
  saveSettings: () => {},
});

export const SettingsProvider = ({ children }) => {
  const [currentSettings, setCurrentSettings] = useState({
    direction: "ltr",
    responsiveFontSizes: true,
    theme: "LIGHT",
  });

  useEffect(() => {
    // Read theme from localStorage set by Next.js
    const savedTheme = localStorage.getItem("theme") || "light";
    const appTheme = savedTheme === "light" ? "LIGHT" : "DARK";

    setCurrentSettings((prev) => ({
      ...prev,
      theme: appTheme,
    }));
  }, []);

  const handleSaveSettings = (update = {}) => {
    const mergedSettings = { ...currentSettings, ...update };
    setCurrentSettings(mergedSettings);

    // Also save to localStorage for next time
    localStorage.setItem("settings", JSON.stringify(mergedSettings));

    // If theme changed, update the shared theme key
    if (update.theme) {
      const sharedTheme = update.theme === "LIGHT" ? "light" : "dark";
      localStorage.setItem("theme", sharedTheme);
    }
  };

  return (
    <SettingsContext.Provider
      value={{
        settings: currentSettings,
        saveSettings: handleSaveSettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
